import React from 'react';

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

function MonthsView({ year, events, onSelectMonth, onYearChange }) {
  // Group event counts per month
  const getMonthEventCount = (monthIdx) => {
    if (!events || events.length === 0) return 0;
    return events.filter(e => {
      if (!e.event_date) return false;
      const parts = e.event_date.split('-');
      const eYear = parseInt(parts[0], 10);
      const eMonth = parseInt(parts[1], 10) - 1;
      return eYear === year && eMonth === monthIdx;
    }).length;
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '16px' }}>
      {/* Year Switcher Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#ffffff', padding: '16px 24px', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#0f172a', margin: 0 }}>
            {year}
          </h2>
          <span style={{ fontSize: '13px', color: '#64748b', fontWeight: '500' }}>
            Select a month to view calendar
          </span>
        </div>

        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <button
            type="button"
            className="action-btn-outlined"
            onClick={() => onYearChange && onYearChange(-1)}
            style={{ padding: '6px 14px', height: '36px' }}
          >
            &lt; Prev Year
          </button>
          <button
            type="button"
            className="action-btn-outlined"
            onClick={() => onYearChange && onYearChange(1)}
            style={{ padding: '6px 14px', height: '36px' }}
          >
            Next Year &gt;
          </button>
        </div>
      </div>

      {/* Grid of Months */}
      <div className="months-grid-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '20px' }}>
        {MONTH_NAMES.map((name, idx) => {
          const count = getMonthEventCount(idx);
          return (
            <div
              key={name}
              className="month-card"
              onClick={() => onSelectMonth(idx)}
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                border: '1px solid var(--border-color, #e2e8f0)',
                padding: '24px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                display: 'flex',
                flexDirection: 'column',
                justify: 'space-between',
                minHeight: '130px',
                position: 'relative'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ fontSize: '18px', fontWeight: '700', color: 'var(--text-main, #0f172a)', margin: 0 }}>
                  {name}
                </h3>
                {count > 0 && (
                  <span
                    style={{
                      backgroundColor: '#eff6ff',
                      color: 'var(--primary-color, #0b66e3)',
                      padding: '4px 10px',
                      borderRadius: '9999px',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '4px'
                    }}
                  >
                    <span style={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: 'var(--primary-color, #0b66e3)' }} />
                    {count} {count === 1 ? 'Event' : 'Events'}
                  </span>
                )}
              </div>

              <div style={{ fontSize: '13px', color: 'var(--text-muted, #64748b)', marginTop: '12px' }}>
                {count > 0 ? `${count} events scheduled` : 'No events scheduled'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MonthsView;
